let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kS4Lw")).then(() => parcelRequire('fPIB7'));